import {
  Datagrid,
  TopToolbar,
  CreateButton,
  ExportButton,
  List,
  ReferenceField,
  SearchInput,
  TextField,
} from "react-admin";
import { useAuth } from "../../../hooks/useAuth";
import { useBulkActionButtons } from "../deleteControls";

const ListActions = ({ isAdmin }) => (
  <TopToolbar>
    {isAdmin && <CreateButton label="Invite New User" />}
    <ExportButton maxResults={25000} />
  </TopToolbar>
);

// #84 - free-text search: partial match on the user's names and email.
const userFilters = [
  <SearchInput source="q" placeholder="Name or email" alwaysOn />,
];

export const UserList = () => {
  const { user, isAdmin, isLiteAdmin } = useAuth();
  return (
    <List
      perPage={25}
      actions={<ListActions isAdmin={isAdmin(user) || isLiteAdmin(user)} />}
      filters={userFilters}
    >
      <Datagrid rowClick="edit" bulkActionButtons={useBulkActionButtons()}>
        <TextField source="email" />
        <TextField source="firstName" />
        <TextField source="lastName" />
        <ReferenceField source="agency" reference="agency">
          <TextField source="name" />
        </ReferenceField>
      </Datagrid>
    </List>
  );
};

export default UserList;
